/* eslint-disable no-negated-condition */
import React, { useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'

function ReadmoreDiscricption(props) {
  const [isReadMore, setIsReadMore] = useState(true)

  const { datakey, data, index } = props
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }

  const cssStyle = {
    main1: {
      width: '17rem',

      overflow: 'auto',
    },
    main2: {
      width: '17rem',
    },
  }

  const cdnurl = AwsConfig.movieCdnUrl

  return (
    <td className='tdclassName' style={{ maxWidth: '300px' }} key={index}>
      {datakey === 'movieListImage' ? (
        <img style={{ width: '6rem' }} src={cdnurl + data[datakey]} />
      ) : (
        ''
      )}
      {datakey === 'posterURL' ? (
        <img style={{ width: '6rem' }} src={cdnurl + data[datakey]} />
      ) : (
        ''
      )}
      {datakey === 'description' ? (
        <p className='text'>
          <span onClick={toggleReadMore} className='read-or-hide'>
            {String(data[datakey]).length >= 100 ? (
              isReadMore ? (
                <div>
                  <b>...read more777</b>
                </div>
              ) : (
                <div>
                  <b>read less</b>
                </div>
              )
            ) : (
              ''
            )}
          </span>
        </p>
      ) : datakey !== 'posterURL' ? (
        <p className='text'>
          {isReadMore ? (
            <div
              style={
                datakey === 'genre_Te' || datakey === 'genre_En' ? cssStyle.main1 : cssStyle.main2
              }
            >
              {datakey === 'movieListImage' ? '' : String(data[datakey]).slice(0, 200)}
            </div>
          ) : (
            <div
              style={
                datakey === 'genre_Te' || datakey === 'genre_En' ? cssStyle.main1 : cssStyle.main2
              }
            >
              {datakey === 'movieListImage' ? '' : data[datakey]}
            </div>
          )}
          <span onClick={toggleReadMore} className='read-or-hide'>
            {String(data[datakey]).length >= 100 ? (
              isReadMore ? (
                <div>
                  <b>...read more</b>
                </div>
              ) : (
                <div>
                  <b>read less</b>
                </div>
              )
            ) : (
              ''
            )}
          </span>
        </p>
      ) : (
        ''
      )}
    </td>
  )
}

export default ReadmoreDiscricption
